import React from 'react';
import { PencilLine, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { billingSource, planStatus } from './planText';

const ADMIN_EMAIL = 'collin@mbscayman.com';

const EditPlanButton = ({ onClick, testId }) => (
  <Button size="sm" variant="outline" onClick={onClick} className="text-amber-700 border-amber-300 hover:bg-amber-50" data-testid={testId}>
    <PencilLine className="w-3 h-3 mr-1" />Edit plan
  </Button>
);

const DeleteButton = ({ onClick, testId }) => (
  <Button size="sm" variant="outline" onClick={onClick} className="text-red-600 border-red-300 hover:bg-red-50" data-testid={testId}>
    <Trash2 className="w-3 h-3 mr-1" />Delete
  </Button>
);

export const UserRow = ({ u, onEdit, onDelete }) => {
  const isAdminUser = u.email === ADMIN_EMAIL;
  const isPro = u.subscription?.startsWith('pro_');
  const source = billingSource(u);
  return (
    <tr className="border-b border-slate-100" data-testid={`user-row-${u.user_id}`}>
      <td className="py-3 px-4">
        <div className="flex items-center gap-2">
          {u.picture ? <img src={u.picture} alt="" className="w-8 h-8 rounded-full shrink-0" />
            : <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center shrink-0">{u.name?.charAt(0) || 'U'}</div>}
          <div className="min-w-0">
            <span className="font-medium block">{u.name || 'Unknown'}{isAdminUser && <span className="ml-2 text-xs text-purple-600 font-medium">Admin</span>}</span>
            <span className="text-sm text-slate-500 block break-all">{u.email}</span>
          </div>
        </div>
      </td>
      <td className="py-3 px-4 whitespace-nowrap">
        <span className={`px-2 py-1 rounded text-xs font-medium ${isPro ? 'bg-amber-100 text-amber-700' : 'bg-slate-100 text-slate-600'}`} data-testid={`user-plan-${u.user_id}`}>
          {planStatus(u).split(' · ')[0]}
        </span>
        {isPro && <span className="text-xs text-slate-500 ml-2" data-testid={`user-expiry-${u.user_id}`}>· {planStatus(u).split(' · ')[1]}</span>}
        {isPro && source && <span className="ml-2 text-[10px] font-bold uppercase tracking-wide text-[#00247D] bg-[#00247D]/10 rounded px-1.5 py-0.5" data-testid={`user-billing-${u.user_id}`}>{source}</span>}
      </td>
      <td className="py-3 px-4 text-slate-500 text-sm whitespace-nowrap">{u.created_at ? new Date(u.created_at).toLocaleDateString() : '-'}</td>
      <td className="py-3 px-4 text-right">
        {isAdminUser ? <span className="text-xs text-slate-400 italic">Protected</span> : (
          <div className="flex items-center justify-end gap-2">
            <EditPlanButton onClick={() => onEdit(u)} testId={`edit-plan-user-${u.user_id}`} />
            <DeleteButton onClick={() => onDelete(u)} testId={`delete-user-${u.user_id}`} />
          </div>
        )}
      </td>
    </tr>
  );
};
